// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"colorPicker_wrapper__3qj8W","text":"colorPicker_text__2Heqa","color":"colorPicker_color__1n4j1","input":"colorPicker_input__39mbu"};